/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import keysOf from"./keys";import valuesOf from"./values";const inspect=function(e){let t,r,s=keysOf(e),f=valuesOf(e),n=s.length;if(t="#<object:{",0===n)return`${t}}>`;for(r=0;r<n;r++)t=`${t+s[r]}:${f[r]}, `;return t=`${t.substr(0,t.length-2)}}>`,t};export default inspect;